import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { setMake } from '../actions/setVehicleConfiguration';
import stepController from '../controllers/StepController';

const Make = ({ setCurrentStep }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	setCurrentStep('make');

	const { accountData, rootDir } = useSelector((state) => state);

	const franchiseList = accountData.accountFranchises;
	const theme = accountData.accountTheme;
	const { widgetName, windowId, deviceType } = useRequestData();
	const addBorderCls = deviceType === 'MOBILE' ? '' : 'border-bottom';

	const handleSetMake = (make) => {
		dispatch(setMake(make));
		trackEvent(widgetName, windowId, {
			element: 'Make option',
			elementCTA: make,
			action: 'clicked',
			result: 'Make selected updated'
		});
	};

	useEffect(() => {
		// reset local storage
		stepController.resetLsVehicleConfig();

		// redirect to single make if we only have 1
		if (franchiseList.length === 1) {
			dispatch(setMake(franchiseList[0]));
			const url = `/${rootDir}/${franchiseList[0]}.htm`;
			navigate(url);
		}
	}, [franchiseList]);

	return (
		<div>
			<div className="m-auto w-100">
				<div
					style={franchiseList === 1 ? { minHeight: '50vh' } : null}
					className={`pb-4 mb-4 car-customizer-flex-container ${addBorderCls}`}
				>
					{franchiseList.length > 1 &&
						franchiseList.map((makeName) => (
							<div
								className="box box-border m-3 p-4 bg-contrast-low rounded box-selection car-customizer-flex-item"
								key={`make_button_${makeName}`}
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center'
								}}
							>
								<Link
									to={`/${rootDir}/${makeName.toLowerCase()}.htm`}
									key={`make_button_${makeName}`}
									onClick={() => handleSetMake(makeName)}
								>
									<img
										className="d-inline-block"
										src={`/static/v8/global/images/franchise-logos/auto/${makeName[0].toLowerCase()}/${makeName
											.replace(' ', '-')
											.toLowerCase()}/${theme}/183x125.png`}
										alt={`${makeName}`}
									/>
									<div className="pt-3">{makeName}</div>
								</Link>
							</div>
						))}
				</div>
			</div>
		</div>
	);
};

Make.propTypes = {
	setCurrentStep: PropTypes.func
};

export default Make;
